import { ReactNode } from 'react'

import { ZenkakuSpace } from '../TextStyle'
import { LinkText } from '@/components/elements/LinkText'

export const scItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>第1条（情報セキュリティ管理体制の構築）</h3>
        <p>
          トライアルグループが保有する全ての情報資産の保護に努め、情報セキュリティに関する法令その他の規範を遵守することにより、社会からの信頼を常に得られるよう、厳重な情報セキュリティ管理体制を構築していきます。
        </p>
      </>
    ),
    id: 'security1',
  },
  {
    children: (
      <>
        <h3>第2条（「情報統括役員」の配置）</h3>
        <p>
          情報統括役員を設置するとともに、情報セキュリティ委員会を組織します。
          これにより全社にわたる情報セキュリティの状況を正確に把握し、必要な対策を迅速に実施できるよう積極的な活動を行います。
        </p>
      </>
    ),
    id: 'security2',
  },
  {
    children: (
      <>
        <h3>第3条（情報セキュリティに関する内部規程の整備）</h3>
        <p>
          情報セキュリティポリシーに基づいた内部規程を整備し、個人情報だけではなく、情報資産全般の取り扱いについて明確な方針を示すとともに、情報漏洩等の情報セキュリティ事故に対しては、厳しい態度で臨むことを社内外に周知徹底します。
        </p>
      </>
    ),
    id: 'security3',
  },
  {
    children: (
      <>
        <h3>第4条（業務委託先の管理体制強化）</h3>
        <p>
          業務委託契約を締結する際には、業務委託先としての適格性を十分に調査した上で、情報資産の
          保護及び秘密を保持させるために必要な契約を締結するとともに、適切な監督を行います。
        </p>
      </>
    ),
    id: 'security4',
  },
  {
    children: (
      <>
        <h3>第5条（教育・研修の実施）</h3>
        <p>
          従業員に情報セキュリティ教育・研修を徹底し、トライアルグループの情報資産に関わる全員が、情報セキュリティの重要性を認識した上で業務を遂行できるようにします。
        </p>
      </>
    ),
    id: 'security5',
  },
  {
    children: (
      <>
        <h3>第6条（情報セキュリティの継続的な改善）</h3>
        <p>
          トライアルグループは情報資産の利用目的・重要度に応じた適切な管理体制を実現するため、情報資産に対する脅威を特定し、継続的にリスク分析・評価を行います。リスク評価の結果に基づいて、特定された脅威に対する合理的な情報セキュリティ対策を実施し、情報資産の安全管理に取り組みます。
        </p>
      </>
    ),
    id: 'security6',
  },
  {
    children: (
      <>
        <h3>第7条（その他）</h3>
        <p>
          個人情報については、別掲の
          <LinkText path="/legal/privacy-policy/" text="「個人情報保護方針」" />
          に準じて管理します。
        </p>
      </>
    ),
    id: 'security7',
  },
  {
    children: (
      <>
        <p>
          制定日
          <ZenkakuSpace />
          2018年10月3日
          <br />
          最終改定日
          <ZenkakuSpace />
          2022年11月22日
        </p>
      </>
    ),
    id: 'signInfo',
  },
]

export const scLinks: {
  name: string
  anchor: string
}[][] = [
  [
    {
      name: '（情報セキュリティ管理体制の構築）',
      anchor: 'security1',
    },
    {
      name: '（「情報統括役員」の配置）',
      anchor: 'security2',
    },
    {
      name: '（情報セキュリティに関する内部規程の整備）',
      anchor: 'security3',
    },
  ],
  [
    {
      name: '（業務委託先の管理体制強化）',
      anchor: 'security4',
    },
    {
      name: '（教育・研修の実施）',
      anchor: 'security5',
    },
    {
      name: '（情報セキュリティの継続的な改善）',
      anchor: 'security6',
    },
  ],
  [
    {
      name: '（その他）',
      anchor: 'security7',
    },
  ],
]
